/**
 * Format shift types from underscored format to plain language
 */
export const formatShiftType = (shiftType: string): string => {
  // Replace underscores with spaces
  const withSpaces = shiftType.replace(/_/g, ' ');
  
  // Capitalize each word
  return withSpaces
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Get color class for system type
 */
export const getSystemColorClass = (system: string): string => {
  const systemMap: Record<string, string> = {
    'food systems': 'bg-green-100 text-green-800',
    'commercial and economic systems': 'bg-blue-100 text-blue-800',
    'neighbourhood and built environment': 'bg-purple-100 text-purple-800',
    'healthcare systems': 'bg-red-100 text-red-800',
    'education systems': 'bg-yellow-100 text-yellow-800',
    'social support systems': 'bg-indigo-100 text-indigo-800',
    'social networks': 'bg-pink-100 text-pink-800',
    'transport systems': 'bg-orange-100 text-orange-800',
  };
  
  return systemMap[system.toLowerCase()] || 'bg-gray-100 text-gray-800';
};

/**
 * Format confidence rating for display
 */
export const formatConfidence = (confidence: number | null): string => {
  if (confidence === null) return 'Not Rated';
  return `${confidence} / 5`;
};

/**
 * Capitalize text and replace underscores with spaces
 */
export const capitalizeText = (text: string): string => {
  return text
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Sort reporting periods chronologically
 */
export const sortPeriodsChronologically = (periods: string[]): string[] => {
  const monthOrder: Record<string, number> = {
    'January': 1, 'February': 2, 'March': 3, 'April': 4,
    'May': 5, 'June': 6, 'July': 7, 'August': 8,
    'September': 9, 'October': 10, 'November': 11, 'December': 12
  };
  
  return periods.sort((a, b) => {
    // Parse periods like "May 2024", "December 2024", etc.
    const parseMatch = (period: string) => {
      const match = period.match(/^(\w+)\s+(\d{4})$/);
      if (!match) return { month: 0, year: 0 };
      
      const month = monthOrder[match[1]] || 0;
      const year = parseInt(match[2], 10);
      return { month, year };
    };
    
    const aParsed = parseMatch(a);
    const bParsed = parseMatch(b);
    
    // Compare years first
    if (aParsed.year !== bParsed.year) {
      return aParsed.year - bParsed.year;
    }
    
    // Then compare months
    return aParsed.month - bParsed.month;
  });
}; 